import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Loading from '../../layouts/Loading'
import Error from '../../layouts/Error'
import { useAuth } from '../../contexts/AuthContext'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import ProfileForm from './forms/ProfileForm'
import { useProfile } from './hooks/useProfile'
import ProfileControlsForm from './forms/ProfileControlsForm'

export default function Profile() {
    const { auth, setAuth } = useAuth()
    const axiosPrivate = useAxiosPrivate()
    const {
        userProfileData,
        message,
        setMessage,
        disabled,
        editDisabled,
        handleClick,
        handleSubmit,
        control,
        // reset,
        handleProfileSubmit,
    } = useProfile({ axiosPrivate, token: auth?.token, setAuth })

    return (
        <Box sx={{ minHeight: '80vh', width: '100%' }}>
            {userProfileData.isPending ? (
                <Loading />
            ) : userProfileData.isError ? (
                <Error error={userProfileData.error} />
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        color: 'text.primary',
                    }}
                >
                    {auth && (
                        <Typography
                            sx={{ mb: 3, width: '100%', textAlign: 'center' }}
                            variant="h4"
                        >
                            {`${auth?.firstName} ${auth?.lastName}`}
                        </Typography>
                    )}

                    <ProfileForm control={control} disabled={disabled} />
                    <ProfileControlsForm
                        editDisabled={editDisabled}
                        disabled={disabled}
                        handleClick={handleClick}
                        handleSubmit={handleSubmit}
                        handleProfileSubmit={handleProfileSubmit}
                        userProfileData={userProfileData}
                        message={message}
                        setMessage={setMessage}
                    />
                </Box>
            )}
        </Box>
    )
}
